import { Endpoints, fetch, normalizeKeys } from '../api'
import rootStore from '../../store/RootStore'

export const fetchChartById = async ({ reportId, componentId }) => {
  if (!reportId || !componentId)
    throw new Error('Missing reportId or componentId')
  
  const filters = [...rootStore.reportStore.filterOptionsSelected.entries()]
    .map(([key, value]) => `${key}=${value.value}`)
    .join('&')
  
  const uri = `${Endpoints.Report}/${reportId}/Component/${componentId}${filters ? `?${filters}` : ''}`
  const response = await fetch(uri)
  return normalizeKeys(response.data)
}

export const fetchLiveChartById = async ({
  productId,
  planId,
  componentId,
  snapshotId,
}) => {
  if (!productId || !planId) throw new Error('Missing productId or planId')

  const filters = [...rootStore.reportStore.filterOptionsSelected.entries()]
    .map(([key, value]) => `${key}=${value.value}`)
    .join('&')

  const base = snapshotId
    ? `${Endpoints.LiveReport}/${productId}/${planId}/snapshot/${snapshotId}`
    : `${Endpoints.LiveReport}/${productId}/${planId}`

  const uri = `${base}/Component/${componentId}${filters ? `?${filters}` : ''}`
  const response = await fetch(uri)
  return normalizeKeys(response.data)
}
